import React, { memo } from 'react';
import TextField from '@material-ui/core/TextField';

const AppInputDate = memo(({ id, name, label, value = '', required = false, onChange, block = true, disabled = false }) => {
  let style = {};

  if (block) {
    style.width = '100%';
  }

  /*const fechaHoy = new Date().getFullYear()+'-01-01'
    if(!value){
        value = fechaHoy
    }*/

  return (
    <TextField
      type="date"
      // inputProps={{maxLength: 8}}
      required={required}
      value={value}
      onChange={onChange}
      id={id}
      name={name}
      label={label}
      style={style}
      disabled={disabled}
      variant="outlined"
    />
  );
});
export default AppInputDate;
